import React, { useState } from 'react';
// @ts-ignore
import permissions from 'invitemember-permissions-model';
import BaseDynamicAPITable from "@/components/Tables/BaseDynamicAPITable";
import classNames from 'classnames';
import ThreeDotsVertical from '@/images/icons/ThreeDotsVertical';
import Dropdown from '@/components/Dropdown';
import { Link } from 'react-router-dom';

export default function TeamTable({ pageSize, filters, delayLoading, setRemoveMemberModalOpen, setMemberToRemove }: any) {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);

	const onRemoveMemberModal = (member: any) => {
		setRemoveMemberModalOpen(true);
		setMemberToRemove(member);
	};

	return (
		<BaseDynamicAPITable
			apiMethod="/project/team"
			pageSize={pageSize}
			filters={filters}
			delayLoading={delayLoading}
			dataModel={{
				columns: [
					{
						header: "Name",
						align: "left",
						render: (row) => {
							const userName = row.firstName + (row.lastName ? ' ' + row.lastName : '');

							return (
								<span className="font-medium">{userName}</span>
							);
						},
						hideHeaderMobile: true,
						fullWidthMobile: true,
						width: 25,
					}, {
						header: "ID",
						align: "left",
						fullWidthMobile: true,
						render: (row) => row.telegramUserId,
					}, {
						header: "Role",
						align: "left",
						fullWidthMobile: true,
						render: (row) => <span className="capitalize">{permissions.getRolesFromUserPermissions(row.teamRoles) ? permissions.getRolesFromUserPermissions(row.teamRoles).name : "Custom"}</span>,
						width: 35,
					}, {
						header: "Actions",
						align: "left",
						hideHeaderMobile: true,
						noTruncate: true,
						render: (row) => (
							<Dropdown
								id={row.telegramUserId}
								button={
									<button className={classNames(
										'btn-secondary w-6 h-6 outline-0 p-0',
										isDropdownOpen && 'bg-[#DFD8CD] border-[#DFD8CD]',
									)}>
										<ThreeDotsVertical className="pointer-events-none" />
									</button>
								}
								className="relative inline-flex md:mt-1"
								top="top-[calc(100%+10px)]"
							>
								<Link
									className="flex items-center py-2.5 px-4 w-full text-white text-sm font-medium border-b border-b-[#313334] last:border-b-0 first:rounded-t-xl last:rounded-b-xl hover:bg-[#313334] transition"
									to={`/member/permissions/${row.userId}`}
								>
									Edit permissions
								</Link>
								<button
									className="flex items-center py-2.5 px-4 w-full text-white text-sm font-medium border-b border-b-[#313334] last:border-b-0 first:rounded-t-xl last:rounded-b-xl hover:bg-[#313334] transition"
									onClick={() => onRemoveMemberModal({
										name: row.firstName + (row.lastName ? ' ' + row.lastName : ''),
										telegramUserId: row.telegramUserId
									})}
								>
									Remove member
								</button>
							</Dropdown>
						),
					}
				]
			}}
			rowLinkTo={(row) => `/member/permissions/${row.userId}`}
			rowLinkState={(row) => row}
		/>
	);

}
